import React, { useState } from 'react'
import './FormUsuario.css'

import { connect } from 'react-redux'
import {
  getConfiguracionesSave,
  toggleUsuario,
  getTextoLegal,
  getTextoCerrarLegal,
  getTextoErrorEmail,
  getTextoNoUser,
  getTextoAvisoCorreo,
  getTextoIdentificarse,
  getTextoRegistrarUsuario,
  getTextoEmail,
  getTextoNombre,
  getTextoMovil,
  getTextoCodigoPostal,
  getTextoAcepto,
  getTextoTerminos,
  getTextoErrorConfiguraciones,
  getTextoErrorCondiciones,
  getTextoErrorNombre,
  getTextoCrearUsuario
} from '../../modules/reducer'

import { useSpring, animated } from 'react-spring'

import { MdClear } from 'react-icons/md'
import { IconContext } from 'react-icons'

import { createUser, identificateUser } from '../drupal'

const validateEmail = email => {
  var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|es|cat|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)\b/
  return re.test(email)
}

const FormUsuario = ({
  idProyecto,
  idioma,
  open,
  configuracion,
  withOpciones,
  toggleUsuario,
  textoLegal,
  textoCerrarLegal,
  textoErrorEmail,
  textoNoUser,
  textoAvisoCorreo,
  textoIdentificarse,
  textoRegistrarUsuario,
  textoEmail,
  textoNombre,
  textoMovil,
  textoCodigoPostal,
  textoAcepto,
  textoTerminos,
  textoErrorConfiguraciones,
  textoErrorCondiciones,
  textoErrorNombre,
  textoCrearUsuario
}) => {
  const [result, setResult] = useState('')
  const [resultIden, setResultIden] = useState('')
  const [openTerms, setOpenTerms] = useState(false)

  const { opacity, display } = useSpring({
    opacity: openTerms ? 1 : 0,
    display: openTerms ? 'block' : 'none'
  })

  return (
    <div className="resumen-user" style={{ display: open ? 'block' : 'none' }}>
      <section className="modal-main-user grid-column-middle">
        <div className="close-resumen" onClick={e => toggleUsuario(false)}>
          <IconContext.Provider
            value={{
              color: '#434343',
              size: '2em'
            }}
          >
            <MdClear />
          </IconContext.Provider>
        </div>
        <animated.div className="modal" style={{ opacity, display }}>
          {textoLegal}
          <div className="modal-cerrar" onClick={e => setOpenTerms(false)}>
            {textoCerrarLegal}
          </div>
        </animated.div>
        <div className="col-10 grid-noGutter" style={{ overflowY: 'auto' }}>
          <h3 style={{ margin: '20px 0 0 0', padding: 0 }}>
            {textoIdentificarse}
          </h3>
          <input
            id="user-email-iden"
            className="input"
            type="text"
            placeholder={textoEmail}
          />
          {resultIden === 'noEmail' ? (
            <div className="col-12">{textoErrorEmail}</div>
          ) : resultIden === 'noUser' ? (
            <div className="col-12">{textoNoUser}</div>
          ) : resultIden !== '' ? (
            <div className="col-12">{textoAvisoCorreo}</div>
          ) : null}
          <div className="col-12">
            <div
              className="button boton-generar-resumen"
              onClick={e => {
                const email = document
                  .getElementById('user-email-iden')
                  .value.trim()
                if (validateEmail(email)) {
                  if (configuracion.length > 0) {
                    createUser(
                      idProyecto,
                      idioma,
                      email,
                      null,
                      null,
                      null,
                      configuracion,
                      setResultIden
                    )
                  } else {
                    identificateUser(idProyecto, idioma, email, setResultIden)
                  }
                } else {
                  setResultIden('noEmail')
                }
              }}
            >
              {textoIdentificarse}
            </div>
          </div>
          <div style={{ width: '100%', border: '1px solid #cdcdcd' }} />
          <h3 style={{ margin: '20px 0 0 0', padding: 0 }}>
            {textoRegistrarUsuario}
          </h3>
          <input
            id="user-email"
            className="input"
            type="text"
            placeholder={textoEmail}
          />

          <input
            id="user-name"
            className="input"
            type="text"
            placeholder={textoNombre}
          />

          <input
            id="user-movil"
            className="input"
            type="text"
            placeholder={textoMovil}
          />
          <input
            id="user-codigo-postal"
            className="input"
            type="text"
            placeholder={textoCodigoPostal}
          />

          <label class="checkbox">
            <input id="user-acept" type="checkbox" />
            {textoAcepto}
            <span
              onClick={e => {
                e.preventDefault()
                setOpenTerms(true)
              }}
              style={{ cursor: 'pointer', color: '#f07204' }}
            >
              {textoTerminos}
            </span>
          </label>

          {result === 'noEmail' ? (
            <div className="col-12">{textoErrorEmail}</div>
          ) : result === 'error' ? (
            <div className="col-12">{textoErrorConfiguraciones}</div>
          ) : result === 'noAcept' ? (
            <div className="col-12">{textoErrorCondiciones}</div>
          ) : result === 'noName' ? (
            <div className="col-12">{textoErrorNombre}</div>
          ) : //) : result === 'noCp' ? (
          //  <div className="col-12">Debe introducir un código postal.</div>
          result !== '' ? (
            <div className="col-12">{textoAvisoCorreo}</div>
          ) : null}
          <div className="col-12">
            <div
              className="button boton-generar-resumen"
              onClick={e => {
                const email = document.getElementById('user-email').value
                const name = document.getElementById('user-name').value
                const movil = document.getElementById('user-movil').value
                const cp = document.getElementById('user-codigo-postal').value
                const acepted = document.getElementById('user-acept').checked
                if (validateEmail(email)) {
                  if (name !== '') {
                    //if (cp !== '') {
                    if (acepted) {
                      createUser(
                        idProyecto,
                        idioma,
                        email,
                        name,
                        movil,
                        cp,
                        configuracion,
                        setResult
                      )
                    } else {
                      setResult('noAcept')
                    }
                    //} else {
                    //  setResult('noCp')
                    //}
                  } else {
                    setResult('noName')
                  }
                } else {
                  setResult('noEmail')
                }
              }}
            >
              {textoCrearUsuario}
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  return {
    idProyecto: reducer.idProyecto,
    idioma: reducer.idioma,
    open: reducer.openUsuario,
    withOpciones: reducer.usuarioWithOpciones,
    configuracion: reducer.usuarioWithOpciones
      ? getConfiguracionesSave(reducer)
      : [],
    textoLegal: getTextoLegal(reducer),
    textoCerrarLegal: getTextoCerrarLegal(reducer),
    textoErrorEmail: getTextoErrorEmail(reducer),
    textoNoUser: getTextoNoUser(reducer),
    textoAvisoCorreo: getTextoAvisoCorreo(reducer),
    textoIdentificarse: getTextoIdentificarse(reducer),
    textoRegistrarUsuario: getTextoRegistrarUsuario(reducer),
    textoEmail: getTextoEmail(reducer),
    textoNombre: getTextoNombre(reducer),
    textoMovil: getTextoMovil(reducer),
    textoCodigoPostal: getTextoCodigoPostal(reducer),
    textoAcepto: getTextoAcepto(reducer),
    textoTerminos: getTextoTerminos(reducer),
    textoErrorConfiguraciones: getTextoErrorConfiguraciones(reducer),
    textoErrorCondiciones: getTextoErrorCondiciones(reducer),
    textoErrorNombre: getTextoErrorNombre(reducer),
    textoCrearUsuario: getTextoCrearUsuario(reducer)
  }
}

const mapDispatchToProps = { toggleUsuario }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormUsuario)
